module.exports = __webpack_public_path__ + "img/logo.8ec57b91.svg";